import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "../locales";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: process.env.VUE_APP_LANGS.split(",").includes(
    localStorage.getItem("currentLang")
  )
    ? localStorage.getItem("currentLang")
    : process.env.VUE_APP_DEFAULT_LANG,
  messages,
});

export default i18n;
